/**
 * Common JS controller.
 *
 * Use this class to run scripts globally and to provide
 * modular helper functions for other scripts classes.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;
const Chart = require( 'chart.js' );

/**
 * Class Common
 */
class Common {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // The accessible outline style container.
        this.focusStyleContainer = $( '#accessible-outline' );

        // Get the galleries
        this.galleries = $( '.gallery' );

        // Add a bit of gallery classes for object-fit to work (needs to be done before
        // this.objectFitContainers)
        this.galleryLinks = this.galleries.find( 'a' );
        this.galleryItemLinks = this.galleries.find( 'img' ).addClass( 'js-object-fit-image' );
        this.galleryLinks.addClass( 'js-object-fit-image-container' );

        // Scan all object-fit-containers on the page.
        this.objectfitContainers = $( '.js-object-fit-image-container' );

        // Assign back to top-element to variable
        this.scrollButton = $( '#js-back-to-top' );

        // Cookie disclaimer
        this.cookieStorageButton = $( '#js-cookie-notice-button' );
        this.cookieDisclaimer    = $( '#js-cookie-notice' );

        // Cache string to control close the gallery and an aria description
        this.closeGalleryString  = themeData.themeStrings.close_gallery;
        this.dialogWindowString  = themeData.themeStrings.dialog_window;
        this.galleryAriaTooltip  = themeData.themeStrings.click_to_enlarge;

        // Last opened element so we know which one to close
        this.openContentElements = {
            prevContent: null,
            prevTarget: null,
            prevButton: null
        };

        // Language dropdown
        this.languageDropdownButton = $( '#js-language-dropdown-toggle' );
        this.languageDropdownMenu   = $( '#js-language-dropdown-menu' );

        // Mobile language menu, the list and its items
        this.mobileLanguageMenuContainer = $( '#js-lang-nav--mobile' );
        this.mobileLanguageMenuList      = $( '#js-lang-nav--mobile__menu' );
        this.mobileLanguageMenuItems     = this.mobileLanguageMenuContainer.find( '.lang-nav--mobile__item' );
        this.languageScrollIndicator     = $( '#js-scroll-indicator' );

        // For toggling footer content
        this.accordionTogglers = $( '.js-accordion-button' );

        // Footer link enhancements for screen readers
        this.footerCards = $( '.footer__card' );

        // Get iframes to recognize Google Maps ones, to make them off limits
        // for screen readers + tab order
        this.iframes = $( 'iframe' );

        // Smooth scrolling for contact info & presentation
        this.smoothScroll = $( '.smooth-scroll' );

        // The top banner and the button to close it
        this.topbanner            = $( '#js-topbanner' );
        this.closeTopBannerButton = $( '#js-close-topbanner' );
        this.showTopBannerButton  = $( '#js-show-topbanner' );
        this.currentTopBannerId   = this.topbanner.attr( 'data-id' );

        // Searchform
        this.searchFormButton = $( '#js-searchform-toggle--projects' );
        this.searchFormFilters = $( '#site-searchform--projects' );

        // Somefeed.
        this.somefeedButtons = $( '.some-feed-button' );
        this.somefeedItem = $( '.some-wall__post-desc' );

        // Webfont loader
        this.webFontLoader();
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Add the outline nullifying style to the
        // container in the document head when using the mouse.
        document.body.addEventListener( 'mousedown', e => {
            this.nullifyOutline();
        });

        // Add the outline nullifying style to the
        // container in the document head on touchevents.
        document.body.addEventListener( 'touchstart', e => {
            this.nullifyOutline();
        });

        // Remove the outline nullifying style from the
        // container in the document head when using the keyboard.
        document.body.addEventListener( 'keydown', e => {
            if ( this.focusStyleContainer ) {
                this.focusStyleContainer.innerHTML = '';
            }
        });

        // Close cookie disclaimer + set local storage info
        this.cookieStorageButton.on( 'click', e => {
            localStorage.setItem( 'cookieDisclaimerClicked', 1 );
            this.cookieDisclaimer.addClass( 'js-hidden' );
        });

        // Toggle language dropdown when clicking the toggler button
        this.languageDropdownButton.on( 'click', ( e ) => {
            this.toggleDropdown();
        });

        // Toggle searchfrom filters when clicking the toggler button
        this.searchFormButton.on( 'click', ( e ) => {
            this.toggleSearchform();
        });

        // Toggle the feedback & footer dropdowns on mobile
        this.accordionTogglers.each( ( e, toggler ) => {
            $( toggler ).on( 'click', ( e ) => {

                // If its the feedback button, open the feedback section. If not, work as a footer dropdown.
                if ( $( toggler ).hasClass( 'js-accordion-button-feedback' ) ) {
                    $( '.feedback__content' ).slideToggle( 'fast' );
                } else {
                    $( e.currentTarget ).siblings( '.js-accordion-content' ).slideToggle( 'fast' );
                }

                // Get the aria expanded status to alter it change it between true and false
                    const ariaExpanded = $( e.currentTarget  ).attr( 'aria-expanded' );

                    // If dropdown was not expanded, it will be now.
                    // Change the togglers aria-expanded to true.
                    if ( ariaExpanded == 'false' ) {
                        $( e.currentTarget  ).attr( 'aria-expanded', 'true' );

                    // If dropdown was wisible, it will be hidden now. Mark the toggler as not expanded
                    } else {
                        $( e.currentTarget  ).attr( 'aria-expanded', 'false' );
                    }
            });
        });

        // Check if the language menu overflows after resizing
        $( window ).on( 'resize', ( e ) => {
            this.mobileLangMenuOverflowCheck();
        });

        // Smooth scrolling
        this.smoothScroll.on ( 'click', ( e ) => {

            e.preventDefault;

            // Get the clicked links href -attribute to know where to scroll to
            const clickedLink = $( e.currentTarget ).attr( 'href' );

            // Get the id to scroll to
            const sectionToScroll = clickedLink.substring( clickedLink.indexOf( '#' ) );

            // Animate the top offset to scroll smoothly
            $( 'html, body' ).animate({
                scrollTop: $( sectionToScroll ).offset().top
            }, 500, ()=> {

                // Focus on the selected section
                $( sectionToScroll ).attr( 'tabindex', '-1' ).focus();
            });
            return false;

        });

        // Bind a click event to top banners close -button to minimize the top banner after click.
        // Save the id for later use, to know if the current banner has been closed before
        this.closeTopBannerButton.on( 'click', () => {

            // Set the banner closed and save the md5 id
            sessionStorage.setItem( 'topBannerClosed', 1 );
            sessionStorage.setItem( 'topBannerId', this.currentTopBannerId );

            // Close the html banner
            this.topbanner.addClass( 'topbanner--shrunk' );
            this.topbanner.removeClass( 'topbanner--show' );
        });

        // Bind a click event to top banners show -button to toggle the full message open
        this.showTopBannerButton.on( 'click', () => {
            this.topbanner.removeClass( 'topbanner--shrunk' );
            this.topbanner.addClass( 'topbanner--show' );
        });

        // Set aria-selected 'true' to selected some feed tab button.
         this.somefeedButtons.on( 'click', ( e ) => this.setButtonActive( e ) );
    }

    /**
     * Web font loader.
     */
    webFontLoader() {

        const WebFont = require( 'webfontloader' );

        WebFont.load({
            google: {
                families: [
                    'Open+Sans:300,400,400i,600'
                ]
            }
        });
    }

    /**
     * Add nullifying outline CSS rules to focusStyleContainer.
     */
    nullifyOutline() {
        if ( this.focusStyleContainer ) {
            this.focusStyleContainer.innerHTML = '*:focus{outline:none!important;}';
        }
    }

    /**
     * Add screen reader texts for each footer card link to make it easier connect the selected link to its context
     */
    footerCardTitles() {
        this.footerCards.each( ( e, item ) => {

            // Get the title and the links
            const title = $( item ).find( '.footer__card-heading' ).html();
            const link = $( item ).find( 'a' );

            // Append the title for screenreaders
            link.append( '<span class="screenreader-only"> ' + title + ', </span>' );
        });

    }

    /**
     * Hide language dropdown
     */
    hideLanguageDropdown() {
        this.languageDropdownMenu.addClass( 'js-hidden' );
    }

    /**
     * Check if mobile language menu overflows and center it if it doesn't. Also, hide the icon indicating a scrollable
     * area if it is not scrollable.
     */
    mobileLangMenuOverflowCheck() {

        // Get the container width
        const menuWidth = $( '#js-lang-nav--mobile' ).width();

        // Create an empty variable for the menu items widths to be added later on
        let menuItemsTotalWidth = 0;

        // Count the combined width of language menu items
        this.mobileLanguageMenuItems.each( ( e, element ) => {
            let itemWidth = $( element ).width();

            // Add paddings
            itemWidth = itemWidth + 16;
            menuItemsTotalWidth = menuItemsTotalWidth + itemWidth;
        });

        // If the language menu items are not long enough to overflow, center them. If they are overflowing, make
        // sure the icon is visible and they are positioned the correct way
        if ( menuItemsTotalWidth < menuWidth ) {
            this.mobileLanguageMenuList.addClass( 'centered-content' );
            this.languageScrollIndicator.addClass( 'js-hidden' );
        } else {
            this.mobileLanguageMenuList.removeClass( 'centered-content' );
            this.languageScrollIndicator.removeClass( 'js-hidden' );
        }

    }

    /**
     * Toggle language dropdown and the togglers aria-expanded status
     */
    toggleDropdown() {

        // Get the aria expanded status to alter it change it between true and false
        const ariaExpanded = $( this.languageDropdownButton ).attr( 'aria-expanded' );

        // If dropdown was not expanded, it will be now.
        // Change the togglers aria-expanded to true.
        if ( ariaExpanded == 'false' ) {
            $( this.languageDropdownButton ).attr( 'aria-expanded', 'true' );

        // If dropdown was wisible, it will be hidden now. Mark the toggler as not expanded
        } else {
            $( this.languageDropdownButton ).attr( 'aria-expanded', 'false' );
        }

        // Toggle the visibility of the language dropdown
        this.languageDropdownMenu.toggleClass( 'js-hidden' );
    }

    /**
     * Scroll back to the top of the page
     */
    backToTop() {

        // Top of the document in pixels
        const documentTop = 0;

        // This is the amount in pixels that user needs to scroll before back to top-button appears
        const distanceFromTop = 750;

        // When the user scrolls down from the top of the document, show the button
        // Push fixed contact us -button out of the way when appearing visible
        $( window ).scroll( () => {
            if ( document.body.scrollTop > distanceFromTop || document.documentElement.scrollTop > distanceFromTop ) {
                this.scrollButton.removeClass( 'js-hidden' );
            } else {
                this.scrollButton.addClass( 'js-hidden' );
            }
        });

        // When the user clicks on the button, scroll to the top of the document
        this.scrollButton.on( 'click', () => {
            document.body.scrollTop = documentTop;
            document.documentElement.scrollTop = documentTop;
        });

    }

     /**
      * Hide Cookie disclaimer if closed before
      */
     cookieDisclaimerCheck() {

        const cookieDisclaimerClicked = localStorage.getItem( 'cookieDisclaimerClicked' );

        if ( cookieDisclaimerClicked == 1 ) {
            this.cookieDisclaimer.addClass( 'js-hidden' );
        }
     }

     /*
     * Switch gallery urls to open the correct sized images instead of full sized ones
     */
    fixGalleryThumbnailUrls() {
        this.galleryLinks.each( ( e, link ) => {

            // Get the url of the child image, which is not full size unless set
            let currentImageUrl = $( link ).children( 'img' ).attr( 'src' );

            if (  $( link ).children( 'img' ).attr( 'srcset' ) ) {

                // Get the images srcset, split them by their commas, get the last
                // item (the biggest dimensions), trim the result, then split it by the space
                // and pick the first item, which is the url.
                currentImageUrl = $( link ).children( 'img' ).attr( 'srcset' ).split( ',' ).pop().trim().split( ' ' )[0];
            }

            // Switch the wanted image size to the thumbnail url
            $( link ).attr( 'href', currentImageUrl );
        });
    }

    /**
     * Shrink top banner if closed before
     */
    topBannerClickedCheck() {

        // Get the current md5 id and the information if the topbanner has
        // been closed before
        const topBannerClosed = sessionStorage.getItem( 'topBannerClosed' );
        const topBannerIdFromStorage = sessionStorage.getItem( 'topBannerId' );

        // Keep the banner minimized if it had been closed before and the current
        // md5 id matches the one in storage
        if ( topBannerClosed == 1 && topBannerIdFromStorage === this.currentTopBannerId ) {
            this.topbanner.addClass( 'topbanner--shrunk' );
        } else {

            // If not, clear sessionStorage and show the banner
            this.topbanner.addClass( 'topbanner--show' );
            sessionStorage.clear();
        }
     }

     /**
     * Create all found galleries. Link galleries with data-group -attribute and set
     * a caption for the Modaal -image from the images <figcaption>
     */
    createGalleries() {

        // If found any galleries, add classes to all the images for the Modaal js
        // library to know that they are gallery images
        if ( this.galleries.length > 0 ) {

            // Go through each gallery and its thumbnail to add them to a data group to separate
            // different galleries on one page
            this.galleries.each( ( index, gallery ) => {

                // Create an aria description div inside of the first gallery - used in all
                // galleries on the same page still
                if ( index == 0 ) {
                    $( gallery ).before( '<div id="aria-gallery-description" class="screenreader-only">' + this.galleryAriaTooltip + '</div>' );
                }

                // Get all the items of the current gallery
                const galleryItems = $( gallery ).find( 'figure' );

                // Get the thumbnail links and mark them as gallery images with gallery-image -class
                this.galleryLinks.addClass( 'gallery-image' );

                // Set an aria description to the image
                this.galleryLinks.attr( 'aria-describedby', 'aria-gallery-description' );

                // Add the data group index to every link
                this.galleryLinks.attr( 'data-group', index );

                // Get the figcaption of an image and set it as a description for a
                // Modaal specific attribute, data-modaal-desc
                galleryItems.each( ( index, singleImage ) => {

                    // Get the description
                    const imageAlt = $( singleImage ).children( 'figcaption' ).text();

                    // Set the description
                    $( singleImage ).find( 'a' ).attr( 'data-modaal-desc', imageAlt );
                });

            });
        }

        // Mark .gallery-image class to be a sign of an image which sould be opened in a modal
        $( '.gallery-image' ).modaal({
            type: 'image',
            background_scroll: false,                  //eslint-disable-line
            close_aria_label: this.closeGalleryString, //eslint-disable-line
            accessible_title: this.dialogWindowString, //eslint-disable-line
            after_open: this.disableBackgroundItemFocusing, //eslint-disable-line
            before_close: this.setInertToFalse         //eslint-disable-line
        });

    }

    /**
     * A function to make all the items unfocusable except the opened lightbox gallery
     */
    disableBackgroundItemFocusing( ) {

        // Check the body if modaal-noscroll class is dynamically added, meaning that the gallery is open.
        if ( $( 'body' ).hasClass( 'modaal-noscroll' ) ) {

            // Not cached for the .modaal-wrapper is generated dynamically, and to make sure we get every item here
            const allContainers = $( 'body' ).children().not( '.modaal-wrapper' );

            // Set inert to true on all the containers outside of the modaal-wrapper
            allContainers.each( ( index, item ) => {

                // Small timeout to make sure this applies to everything - without timeout this won't work
                window.setTimeout( item.inert = true, 100 );

            });
        }
    }

    /**
     * Set inert to false on all items, used after closing the lightbox gallery - this makes the items
     * focusable again.
     */
    setInertToFalse() {

        // Not cached, to make sure we have everything
        const allContainers = $( 'body' ).children().not( '.modaal-wrapper' );

        // Set inert to true on all the containers outside of the modaal-wrapper
        allContainers.each( ( index, item ) => {
            item.inert = false;
        });
    }

    /**
     * Remove Google Maps iframes from taborder
     */
    removeMapsFromTaborder() {

        this.iframes.each( ( e, item ) => {
            const iframeSrc = $( item ).attr( 'src' );
            let domain = '';

            if ( iframeSrc ) {
                domain = iframeSrc.replace( 'http://', '' ).replace( 'https://', '' ).replace( 'www.', '' ).split( /[/?#]/ )[0];

                if ( domain == 'google.com' || domain == 'kartta.vaasa.fi' ) {
                    $( item ).attr( 'tabindex', '-1' );
                };
            }
        });
    }

    /**
     * Fallback for object fit.
     */
    objectFitFallback() {

        // IE and Edge CSS Object fit fallback javascript
        if ( ! Modernizr.objectfit ) {

            // Loop through object fit containers.
            this.objectfitContainers.each( function() {

                // Variables
                const $container = $( this );
                const imgUrl     = $container.find( 'img' ).prop( 'src' );

                if ( imgUrl ) {
                    $container
                    .css( 'backgroundImage', 'url(' + imgUrl + ')' )
                    .addClass( 'compat-object-fit' );
                }
            });
        } // End if().
    }

    /**
     * Print doughnut chart.
     */
    printChart() {
        Number.prototype.round = function( places ) {
            return +( Math.round( this + 'e+' + places )  + 'e-' + places );
        };

        if ( themeData.distribution ) {
            let myChart = new Chart( this.chart, {
                type: 'doughnut',
                data: {
                    labels: [ themeData.themeStrings.project.sustainable_development, themeData.themeStrings.project.wellbeing, themeData.themeStrings.project.vitality_knowhow ],
                    datasets: [ {
                        label: '%',
                        data: [ themeData.distribution[0].percentage, themeData.distribution[1].percentage, themeData.distribution[2].percentage ],
                        backgroundColor: [
                            'rgba(0, 10, 140, 1)',
                            'rgba(110, 200, 210, 1)',
                            'rgba(255, 180, 170, 1)'
                        ],
                        borderWidth: 0
                    } ]
                },
                options: {
                    cutoutPercentage: 50,
                    responsive: false,
                    maintainAspectRatio: false,
                    legendCallback: function( chart ) {
                        let text = [];
                        text.push( '<ul class="chart-legend" style="list-style: none;">' );

                        let data = chart.data;
                        let datasets = data.datasets;
                        let labels = data.labels;

                        if ( datasets.length ) {
                            for ( let i = 0; i < datasets[0].data.length; ++i ) {
                                text.push( '<li class="chart-legend__item"><span class="color-bubble" style="background-color:' + datasets[0].backgroundColor[i] + '"></span>' );
                                if ( labels[i]) {

                                    // calculate percentage
                                    let total = datasets[0].data.reduce( function( previousValue, currentValue, currentIndex, array ) {
                                        return previousValue + currentValue;
                                    });
                                    let currentValue = datasets[0].data[i];
                                    let percentageVal = ( currentValue / total ) * 100;
                                    let percentage = percentageVal.round( 2 );

                                    text.push( labels[i] + ' (' + percentage + '%)' );
                                }
                                text.push( '</li>' );
                            }
                        }
                        text.push( '</ul>' );
                        return text.join( '' );
                    },
                    legend: {
                        display: false
                    },
                    tooltips: {
                        callbacks: {
                            afterLabel: function( tooltipItem, data ) {
                                return '%';
                            }
                        }
                    },
                    plugins: {
                        labels: {
                            render: 'percentage',
                            fontColor: [ 'white', 'white', 'black' ],
                            precision: 2
                        }
                    }
                }
            });

            const jsLegend = document.getElementById( 'js-legend' );

            if ( jsLegend ) {
                jsLegend.innerHTML = myChart.generateLegend();
            }
        }
    }

    /**
     * Toggle searchform filters and the toggler aria-expanded status
     */
    toggleSearchform() {

        // Get the aria expanded status to alter it change it between true and false
        const ariaExpanded = $( this.searchFormButton ).attr( 'aria-expanded' );

        // If filters was not expanded, it will be now.
        // Change the togglers aria-expanded to true.
        if ( ariaExpanded == 'false' ) {
            $( this.searchFormButton ).attr( 'aria-expanded', 'true' );
            $( this.searchFormButton ).find( 'i' ).addClass( 'fas' ).removeClass( 'fal' );

            // If filters was wisible, it will be hidden now. Mark the toggler as not expanded
        } else {
            $( this.searchFormButton ).attr( 'aria-expanded', 'false' );
            $( this.searchFormButton ).find( 'i' ).addClass( 'fal' ).removeClass( 'fas' );
        }

        // Toggle the visibility of the filters
        this.searchFormFilters.toggleClass( 'js-hidden' );
    }

    /**
     * Set button to aria-selected 'true' state.
     *
     * @param {object} e Click event.
     */
     setButtonActive( e ) {
        const $btn = $( e.currentTarget );
        $btn.attr( 'aria-selected', true ).siblings().attr( 'aria-selected', false );
        $btn.parent().addClass( 'active' );
    }

    trimSomeItem() {
        this.somefeedItem.each( function() {
            if ( $( this ).text().length >= 280 ) {
                $( this ).addClass( 'has-overflow' );
            }
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.objectFitFallback();
        this.footerCardTitles();
        this.hideLanguageDropdown();
        this.backToTop();
        this.cookieDisclaimerCheck();
        this.fixGalleryThumbnailUrls();
        this.createGalleries();
        this.mobileLangMenuOverflowCheck();
        this.removeMapsFromTaborder();
        this.topBannerClickedCheck();
        this.trimSomeItem();

        // this.printChart(); // Not needed for now.
        this.toggleSearchform();
    }

    /**
     * Offers safe way to stop a JS event.
     *
     * Example usage:
     * Theme.Common.stop(e);
     *
     * @param e Event object.
     */
    static stop( e ) {
        e.preventDefault ? e.preventDefault() : ( e.returnValue = false );
    }

    /**
     * This gets a URL parameter according to given parameter string.
     *
     * @param {string} name
     */
    static getUrlParameter( name ) {
        name          = name.replace( /[\[]/, '\\[' ).replace( /[\]]/, '\\]' );
        const regex   = new RegExp( '[\\?&]' + name + '=([^&#]*)' );
        const results = regex.exec( location.search );

        return results === null ? false : decodeURIComponent( results[1].replace( /\+/g, ' ' ) );
    };

    /**
     * This is a custom empty check for parameters.
     *
     * @param {mixed} param The given parameter
     */
    static empty( param ) {
        if ( typeof param == undefined || param == '' || param == null || param == false || param.length == 0 ) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Select a list of matching child elements from an array of elements.
     *
     * @param  {object} elements A nodelist. Use each item in nodelist as context when finding the children.
     * @param  {string} selector The query selector string.
     * @return {object]}   Returns empty array if no matches are found; otherwise, it returns all matching elements.
     */
    static childrenFromEach( elements, selector ) {

        // Return empty array if missing required attributes or elements empty
        if ( ! elements || ! selector || ! elements.length > 0 ) {
            return [];
        }

        const arrayOfNodes = Array.prototype.map.call( elements,
            function( element ) {

                // Get all matching elements.
                const matchingChildren = ( element ).querySelectorAll( selector );

                // Convert nodelist to array.
                return [ ...matchingChildren ];
            }
        );

        // Flatten the array
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce?v=a
        const flattened = arrayOfNodes.reduce( ( a, b ) => [ ...a, ...b ]);
        return flattened;
    }

    /**
     * Toggles the state of an elements aria-hidden attribute. If the element does not have an aria-hidden attribute,
     * one will be created and set to false.
     *
     * @param {object} elements The nodelist containing the elements
     * @return {void}
     */
    static toggleAriaHidden( element ) {
        const ariaExpandedState = element.getAttribute( 'aria-hidden' ) === 'false' ? true : false;
        element.setAttribute( 'aria-hidden', ariaExpandedState );
    }


    /**
     * Select a list of matching elements, context is optional.
     *
     * @param  {string} selector The query selector string.
     * @param  {object} context  A query context object.
     * @return {object}          Returns empty nodelist if no matches are found; otherwise, it returns a nodelist of matching elements.
     */
    static $( selector, context ) {
        return ( context || document ).querySelectorAll( selector );
    }

    /**
     * Select the first match only, context is optional.
     *
     * @param  {string} selector The query selector string.
     * @param  {object} context  A query context object.
     * @return {object|null}     Returns null if no matches are found; otherwise, it returns the first matching element.
     */
    static $1( selector, context ) {
        return ( context || document ).querySelector( selector );
    }

    static getUrlParameter( name ) {
        name          = name.replace( /[\[]/, '\\[' ).replace( /[\]]/, '\\]' );
        const regex   = new RegExp( '[\\?&]' + name + '=([^&#]*)' );
        const results = regex.exec( location.search );

        return results === null ? false : decodeURIComponent( results[1].replace( /\+/g, ' ' ) );
    };
}

// Export the class reference.
module.exports = Common;



// WEBPACK FOOTER //
// ../vaasa/assets/scripts/common.js